/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterState } from '../../models/work-center-state';

export interface GetCurrentState$Params {
  workCenterId: number;
}

export function getCurrentState(http: HttpClient, rootUrl: string, params: GetCurrentState$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterState>> {
  const rb = new RequestBuilder(rootUrl, getCurrentState.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterState>;
    })
  );
}

getCurrentState.PATH = '/api/v1/WorkCenter/{workCenterId}/CurrentState';
